export default function(data) {
var __t, __p = '';
__p += '<div class="flash-text">\n  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">\n    <g fill="none" fill-rule="evenodd">\n      <circle fill="#0E3651" cx="12" cy="12" r="12" />\n      <path d="M5 5h14.092v14.092H5z" />\n      <path stroke="#FFF" stroke-width="1.542" fill="#FFF" fill-rule="nonzero"\n        d="M10.284 14.494l-2.448-2.448-.834.828 3.282 3.282L17.33 9.11l-.828-.828z" />\n    </g>\n  </svg>\n  <span>' +
((__t = ( data.msg )) == null ? '' : __t) +
'</span>\n</div>\n<i class="material-icons close-msg">clear</i>\n';
return __p
}